import { Button, Input } from "@nextui-org/react";
import { useState } from "react";
import { Link, Navigate, useNavigate, redirect } from "react-router-dom";
import fetchWrapper from "../utils/fetch";
import { useAuth } from "../contexts/auth-context";
import { toast } from "react-toastify";

export async function action({ request }) {
  const formData = await request.formData();
  const updates = Object.fromEntries(formData);

  try {
    await fetchWrapper.post("/signup", updates);
    return redirect("/login");
  } catch (err) {
    if (err.detail === "Username already registered") {
      return { error: "این نام کاربری قبلاً ثبت شده است" };
    } else if (err.detail === "Email already registered") {
      return { error: "این ایمیل قبلاً ثبت شده است" };
    }
    return { error: err?.detail || "خطا در ثبت نام" };
  }
}

export default function SignupPage() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const [{ isAuthenticated, status }] = useAuth();

  const isLoading = status === "loading";

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const updates = Object.fromEntries(formData);

    try {
      await fetchWrapper.post("/signup", updates);
      navigate("/login");
    } catch (err) {
      if (err?.detail === "Username already registered") {
        toast.error("این نام کاربری قبلاً ثبت شده است");
      } else if (err?.detail === "Email already registered") {
        toast.error("این ایمیل قبلاً ثبت شده است");
      } else {
        toast.error(err?.detail || "خطا در ثبت نام");
      }
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900">
            ثبت نام در حساب کاربری
          </h2>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <Input
                name="email"
                type="email"
                label="ایمیل"
                required
                className="mb-4"
                startContent={
                  <svg
                    aria-hidden="true"
                    fill="none"
                    focusable="false"
                    height="1em"
                    role="presentation"
                    viewBox="0 0 24 24"
                    width="1em"
                    className="text-2xl text-default-400 pointer-events-none flex-shrink-0"
                  >
                    <path
                      d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />
            </div>
            <div>
              <Input
                name="username"
                type="text"
                label="نام کاربری"
                required
                className="mb-4"
              />
            </div>
            <div>
              <Input
                name="first_name"
                type="text"
                label="نام"
                required
                className="mb-4"
              />
            </div>
            <div>
              <Input
                name="last_name"
                type="text"
                label="نام خانوادگی"
                required
                className="mb-4"
              />
            </div>
            <div>
              <Input
                name="password"
                type={passwordVisible ? "text" : "password"}
                label="رمز عبور"
                required
                className="mb-4"
                endContent={
                  <button
                    className="focus:outline-none"
                    type="button"
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    {passwordVisible ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    )}
                  </button>
                }
              />
            </div>
          </div>

          <div>
            <Button
              type="submit"
              color="primary"
              className="w-full"
              isLoading={isLoading}
            >
              ثبت نام
            </Button>
          </div>
        </form>

        <div className="flex flex-col items-center space-y-2">
          <Link to="/login" className="text-primary hover:text-primary-dark">
            قبلاً ثبت نام کرده‌اید؟
          </Link>
          <Link to="/forgot-password" className="text-sm text-gray-600 hover:text-gray-900">
            رمز عبور خود را فراموش کرده‌اید؟
          </Link>
        </div>
      </div>
    </div>
  );
}
